import { i18n } from '@/plugins/i18n'
import { check } from '@/plugins/helper'
import Vue from '../../main.js'

const getDefaultState = () => {
  return {
    address                        : "",
    dob                            : "",
    email                          : "",
    employerName                   : "",
    employmentSector               : "",
    fullName                       : "",
    gender                         : "M",
    identificationNo               : "",
    nationality                    : "",
    nationalityId                  : "",
    occupation                     : "",
    passExpiryDate                 : "",
    passStatus                     : "",
    passType                       : "",
    residentialStatus              : "",
    residentialStatusId            : 0,

    myInfoState                    : "",
    myInfoCode                     : "",
    enabledField                   : "",
    occupationList                 : [],
    industryList                   : [],
    nationalityList                : [],

    validation: {
      isIdentificationNoValid      : false,
      isFullnameValid              : false,
      isGenderValid                : true, // SET TO TRUE SINCE ALREADY HAVE DFAULT VALUE
      isDobValid                   : false,
      isNationalityValid           : false,
      isPassTypeValid              : true, // SET TO TRUE SINCE ITS FIELD IS ALWAYS DISABLED
      isPassStatusValid            : true, // SET TO TRUE SINCE ITS FIELD IS ALWAYS DISABLED
      isEmpoymentSectorValid       : false,
      isEmailValid                 : false,
      isAddressValid               : false,
      isEmployerValid              : false,
      isOccupationValid            : false,
      isValidForm                  : false,
      isValidCheckOnlySpecial      : false,
    },

    showHideInput       : {
      identificationNo  : false,
      fullName          : false,
      gender            : false,
      dob               : false,
      residentialStatus : false,
      nationality       : false,
      passType          : false,
      passStatus        : false,
      passExpiryDate    : false,
      employerName      : false,
      employmentSector  : false,
      email             : false,
      address           : false,
      occupation        : false,
    },

    routerTo            : "",
  }
}

const state = getDefaultState()

const getters = {
  address: (state) => {
    return state.address
  },
  dob: (state) => {
    return state.dob
  },
  dobForPicker: (state) => {
    if(state.dob == '') {
      return ''
    }

    const dobArr = state.dob.split("-")
    const year = dobArr[2]
    const month = dobArr[1]
    const day = dobArr[0]
    return [year, month, day].join('-')
  },
  email: (state) => {
    return state.email
  },
  employerName: (state) => {
    return state.employerName
  },
  employmentSector: (state) => {
    return state.employmentSector
  },
  fullName: (state) => {
    return state.fullName
  },
  gender: (state) => {
    if(state.gender=="M"){
      return "Male"
    }else{
      return "Female"
    }
    //return state.gender
  },
  identificationNo: (state) => {
    return state.identificationNo
  },
  nationality: (state) => {
    return state.nationality
  },
  nationalityId: (state) => {
    return state.nationalityId
  },
  occupation: (state) => {
    return state.occupation
  },
  passExpiryDate: (state) => {
    return state.passExpiryDate
  },
  passStatus: (state) => {
    return state.passStatus
  },
  passType: (state) => {
    return state.passType
  },
  residentialStatus: (state) => {
    return state.residentialStatus
  },
  residentialStatusId: (state) => {
    return state.residentialStatusId
  },
  myInfoState: (state) => {
    return state.myInfoState
  },
  myInfoCode: (state) => {
    return state.myInfoCode
  },
  enabledField: (state) => {
    return state.enabledField
  },
  industryList: (state) => {
    return state.industryList
  },
  occupationList: (state) => {
    return state.occupationList
  },
  nationalityList: (state) => {
    return state.nationalityList
  },
  validation: (state) => {
    return state.validation
  },
  showHideInput: (state) => {
    return state.showHideInput
  },
  routerTo: (state) => {
    return state.routerTo
  },
}

const actions = {
  /* VALIDATE INPUT */
  async validateInput({ state, dispatch/*, commit*/ }, inputEl) {
      let isValidInput           = false;
      //console.log("INPUT ID : "+inputEl.id)
      // ID NO
      if(inputEl.id === "identificationNo") {
          await dispatch('validateIdentificationNo', inputEl.value);
          isValidInput = state.validation.isIdentificationNoValid;
      }
      // FULLNAME
      else if(inputEl.id === "fullname") {
          await dispatch('validateFullname', inputEl.value);
          isValidInput = state.validation.isFullnameValid;
      }
      // GENDER
      else if(inputEl.id === "gender") {
          await dispatch('validateGender', inputEl.value);
          isValidInput = state.validation.isGenderValid;
      }
      // DOB
      else if(inputEl.id === "dob") {
          await dispatch('validateDob', inputEl.value);
          isValidInput = state.validation.isDobValid;
      }
      // NATIONALITY
      else if(inputEl.id === "nationality") {
          await dispatch('validateNationality', inputEl.value);
          isValidInput = state.validation.isNationalityValid;
      }
      // EMPLOYMENT SECTOR
      else if(inputEl.id === "employmentSector") {
          await dispatch('validateEmploymentSector', inputEl.value);
          isValidInput = state.validation.isEmpoymentSectorValid;
      }
      // EMAIL
      else if(inputEl.id === "email") {
          await dispatch('validateEmail', inputEl.value);
          isValidInput = state.validation.isEmailValid;
      }
      // ADDRESS
      else if(inputEl.id === "address") {
          await dispatch('validateAddress', inputEl.value);
          isValidInput = state.validation.isAddressValid;
      }
      // EMPLOYER NAME
      else if(inputEl.id === "employerName") {
          await dispatch('validateEmployer', inputEl.value);
          isValidInput = state.validation.isEmployerValid;
      }
      // OCCUPATION
      else if(inputEl.id === "occupation") {
          await dispatch('validateOccupation', inputEl.value);
          isValidInput = state.validation.isOccupationValid;
      }
      else {
          isValidInput = true;
      }

      await Vue.setInputState(inputEl.id, isValidInput);

      // CHECK ENABLED FIELDS
      const arrEnabledField = state.enabledField.split(',')
      /*
        1 = name
        2 = identification no
        3 = gender
        4 = nationality
        5 = dob
        6 = email
        7 = occupation
        8 = employment sector
        9 = address
        10 = employer
      */

      let isValid = ((arrEnabledField.includes("2") && state.showHideInput.identificationNo) ? state.validation.isIdentificationNoValid == true : true)
                    && ((arrEnabledField.includes("1") && state.showHideInput.fullName) ? state.validation.isFullnameValid == true : true) 
                    && ((arrEnabledField.includes("3") && state.showHideInput.gender) ? state.validation.isGenderValid == true : true)
                    && ((arrEnabledField.includes("5") && state.showHideInput.dob) ? state.validation.isDobValid == true : true)
                    && ((arrEnabledField.includes("4") && state.showHideInput.nationality) ? state.validation.isNationalityValid == true : true) 
                    && ((arrEnabledField.includes("8") && state.showHideInput.employmentSector) ? state.validation.isEmpoymentSectorValid == true : true)
                    && ((arrEnabledField.includes("6") && state.showHideInput.email) ? state.validation.isEmailValid == true : true) 
                    && ((arrEnabledField.includes("9") && state.showHideInput.address) ? state.validation.isAddressValid == true : true)
                    && ((arrEnabledField.includes("10") && state.showHideInput.employerName) ? state.validation.isEmployerValid == true : true)
                    && ((arrEnabledField.includes("7") && state.showHideInput.occupation) ? state.validation.isOccupationValid == true : true)
      /*
      console.log("arrEnabledField : ", arrEnabledField)
      console.log("isIdentificationNoValid : " + state.validation.isIdentificationNoValid + " # " +state.showHideInput.identificationNo)
      console.log("isFullnameValid : " + state.validation.isFullnameValid+ " # " +state.showHideInput.fullName)
      console.log("isGenderValid : " + state.validation.isGenderValid + " # " +state.showHideInput.gender)
      console.log("isDobValid : " + state.validation.isDobValid + " # " +state.showHideInput.dob)
      console.log("isNationalityValid : " + state.validation.isNationalityValid + " # " +state.showHideInput.nationality)
      console.log("isEmpoymentSectorValid : " + state.validation.isEmpoymentSectorValid + " # " +state.showHideInput.employmentSector)
      console.log("isEmailValid : " + state.validation.isEmailValid + " # " +state.showHideInput.email)
      console.log("isAddressValid : " + state.validation.isAddressValid + " # " +state.showHideInput.address)
      console.log("isEmployerValid : " + state.validation.isEmployerValid + " # " +state.showHideInput.employerName)
      console.log("isOccupationValid : " + state.validation.isOccupationValid + " # " +state.showHideInput.occupation)
      console.log("isFormValid : "+ isValid)
      */
      dispatch('setIsValidForm', isValid);
  },
  /* END OF VALIDATE INPUT */

  validateIdentificationNo({ commit }, value) {
      let idNo         = value != undefined ? value : '';
      let isValidInput = true;
      let inputState   = "";
      let msg          = "";

      isValidInput = idNo.trim() == "" ? false : true; // check.validPattern("documentid189", idNo);
      msg          = i18n.t('ua-id-no-help');

      inputState = isValidInput ? true : msg;
      commit('setIsIdentificationNoValid', inputState);
  },

  async validateFullname({ commit, state, dispatch }, value) {
      let fullName      = value != undefined ? value : '';
      let isValidInput  = true;
      let inputState    = "";

      let msg1 = i18n.t('ua-fullname-error1');
      let msg2 = i18n.t('ua-fullname-error2');
      let msg3 = i18n.t('ua-fullname-error3');
      

      await dispatch('checkPreventOnlySpecial', fullName);
      let chkSpcResult = state.validation.isValidCheckOnlySpecial;
      if(chkSpcResult < 0) {
          isValidInput = false;
          switch(chkSpcResult) {
              case -1:
                  inputState = isValidInput ? true : msg1;
                  break;
              case -2:
                  inputState = isValidInput ? true : msg2;
                  break;
              case -3:
                  inputState = isValidInput ? true : msg3;
                  break;
          }
      } else {
          isValidInput = true;
          inputState   = true;
      }
      await commit('setIsFullnameValid', inputState);
  },

  validateGender({ commit }, value) {
      let gender        = value != undefined ? value : '';
      let isValidInput  = true;
      let inputState    = "";
      let msg           = "";

      isValidInput = gender == "" ? false : true;
      msg          = i18n.t('regis-gender-empty');

      inputState = isValidInput ? true : msg;
      commit('setIsGenderValid', inputState);
  },

  validateNationality({ commit }, value) {
      let isValidInput  = true;
      let inputState    = "";
      let msg           = "";

      isValidInput = (value > 0) ? true : false;
      msg          = i18n.t('regis-nationality-empty');

      inputState = isValidInput ? true : msg;
      commit('setIsNationalityValid', inputState);
  },

  validateDob({ commit }, value) {
      let dob          = value != undefined ? value : '';
      let isValidInput = true;
      let inputState   = "";
      let msg          = "";


      if(dob.length == 0) {
          isValidInput = false;
          msg          = i18n.t('reset-dob-empty');
      } else {
          let split = dob.split("-");
          let day   = split[0];
          let month = split[1];
          let year  = split[2];

          if((month == 4 || month == 6 || month == 9 || month == 11) && day == 31) {
              isValidInput = false;
              msg          = i18n.t('ua-dob-error');
          }

          if(month == 2) {
              var leap = (year % 4 == 0 && (year % 100 != 0 || year % 400 == 0));
              if (day > 29 || (day == 29 && !leap)) {
              isValidInput = false;
              msg          = i18n.t('ua-dob-error');
              }
          }
      }

      inputState = isValidInput ? true : msg;
      commit('setIsDobValid', inputState);
  },

  validateEmploymentSector({ commit }, value) {
      let employmentSector          = value != undefined ? value : '';
      let isValidInput              = true;
      let inputState                = "";
      let msg                       = "";

      isValidInput = (employmentSector != "") ? true : false;
      msg          = i18n.t('ua-employment-sector-empty');

      inputState = isValidInput ? true : msg;
      commit('setIsEmpoymentSectorValid', inputState);
  },

  validateEmail({ commit }, value) {
      let email        = value != undefined ? value : '';
      let isValidInput = true;
      let inputState   = "";
      let msg          = "";

      if(email.length > 0) {
        isValidInput = check.validPattern("email", email);
        msg = i18n.t('regis-email-rule');
      }else{
        isValidInput = false;
        msg = i18n.t('regis-email-empty');
      }

      inputState = isValidInput ? true : msg;
      commit('setIsEmailValid', inputState);
  },

  validateAddress({ commit }, value) {
      let address                   = value != undefined ? value : '';
      let isValidInput              = true;
      let inputState                = "";
      let msg                       = "";

      isValidInput = (address != "") ? true : false;
      msg          = i18n.t('ua-address-help');

      inputState = isValidInput ? true : msg;
      commit('setIsAddressValid', inputState);
  },

  validateEmployer({ commit }, value) {
      let employerName              = value != undefined ? value : '';
      let isValidInput              = true;
      let inputState                = "";
      let msg                       = "";

      isValidInput = (employerName != "") ? true : false;
      msg          = i18n.t('regis-name-employer-help');

      inputState = isValidInput ? true : msg;
      commit('setIsEmployerValid', inputState);
  },


  validateOccupation({ commit/*, state */}, occupation) {
      let isValidInput = true;
      let msg          = "";
      let inputState   = "";
      if(occupation.length > 2) {
        const isValidOccupationPattern = check.validPattern("occupation", occupation)
        const isValidOccupation = check.validateNullEquivalent(occupation.trim());
        
        let tmpOccupationMsg = !isValidOccupation ? i18n.t('regis-occupation-rule3') : i18n.t('regis-occupation-rule');


        isValidInput = isValidOccupationPattern && isValidOccupation;
        msg = tmpOccupationMsg
      }else{
        isValidInput = false;
        msg = i18n.t('regis-occupation-empty');
      }

      if(isValidInput){
        inputState                          = true;
        //state.validation.isOccupationValid  = true;
      }else{
        inputState                          = msg;
        //state.validation.isOccupationValid  = false;
      }
      Vue.setInputState("occupation", inputState);
      commit('setIsOccupationValid', inputState);
  },

  checkPreventOnlySpecial({ commit }, value) {
      let specialList  = ['.', ',', '!', '!', '{ ', '}', '<', '>', '?', ':', ';', '\u2013', '\u2014', '-', '(', ')', '[', ']', '\'', '"', '\u2018', '\u0060', '\u2019', '\u201C', '\u201D', '^', '@', '~', '`', '$', '%', '*', '_', '|', '/', '&'];
      let val          = value;
      let removedWhite = val.replace(/\s+/g,'');
      let len          = val.length, removedLen = removedWhite.length;
      let i            = 0, spcCount = 0, checkChar = 0;
      if(len == 0) { // must not be empty!
          commit('loadCheckPreventOnlySpecial', -1);
      } else if(removedLen == 0) { // considered error, because the value contains only white spaces.
          commit('loadCheckPreventOnlySpecial', -2);
      } else {
          spcCount = 0;
          for(i = 0; i < removedLen; i++) {
              checkChar = removedWhite.charAt(i);
              if(specialList.indexOf(checkChar)>-1) { // if in list of Special Character, add to count.
                  spcCount++;
              }
          }
          if(spcCount == removedLen) { // considered error, because the value contains only special characters.
              commit('loadCheckPreventOnlySpecial', -3);
          } else {
              commit('loadCheckPreventOnlySpecial', 0);
          }
      }
  },

  showHideInputForm({ state }){
    if(parseInt(state.residentialStatusId) == 2 || parseInt(state.residentialStatusId) == 3){
      state.showHideInput.identificationNo = true;
      state.showHideInput.fullName = true;
      state.showHideInput.gender = true;
      state.showHideInput.dob = true;
      state.showHideInput.residentialStatus = true;
      state.showHideInput.nationality = true;
      state.showHideInput.passType = false;
      state.showHideInput.passStatus = false;
      state.showHideInput.passExpiryDate = false;
      state.showHideInput.employerName = false;
      state.showHideInput.employmentSector = true;
      state.showHideInput.email = true;
      state.showHideInput.address = true;
      state.showHideInput.occupation = true;
    }else{
      state.showHideInput.identificationNo = true;
      state.showHideInput.fullName = true;
      state.showHideInput.gender = true;
      state.showHideInput.dob = true;
      // DR-1931: residentialStatus is an SG/PR-only field (the "if" branch above) — it must NOT
      // show for foreigners/pass-holders, which is what this "else" branch represents. It was
      // wrongly set true in both branches, so it always rendered regardless of residency status.
      state.showHideInput.residentialStatus = false;
      state.showHideInput.nationality = true;
      state.showHideInput.passType = true;
      state.showHideInput.passStatus = true;
      state.showHideInput.passExpiryDate = true;
      state.showHideInput.employerName = true;
      state.showHideInput.employmentSector = true;
      state.showHideInput.email = true;
      state.showHideInput.address = true;
      state.showHideInput.occupation = true;
    }
  },
  setAddress({ commit }, value) { 
    commit('setAddress', value);
  },
  setDob({ commit }, value) { 
    commit('setDob', value);
  },
  setEmail({ commit }, value) { 
    commit('setEmail', value);
  },
  setEmployerName({ commit }, value) { 
    commit('setEmployerName', value);
  },
  setEmploymentSector({ commit }, value) { 
    commit('setEmploymentSector', value);
  },
  setFullname({ commit }, value) { 
    commit('setFullname', value);
  },
  setGender({ commit }, value) { 
    commit('setGender', value);
  },
  setIdentificationNo({ commit }, value) { 
    commit('setIdentificationNo', value);
  },
  setNationality({ commit }, value) { 
    commit('setNationality', value);
  },
  setOccupation({ commit }, value) { 
    commit('setOccupation', value);
  },
  setPassExpiryDate({ commit }, value) { 
    commit('setPassExpiryDate', value);
  },
  setPassStatus({ commit }, value) { 
    commit('setPassStatus', value);
  },
  setPassType({ commit }, value) { 
    commit('setPassType', value);
  },
  setResidentialStatus({ commit }, value) { 
    commit('setResidentialStatus', value);
  },
  setMyInfoState({ commit }, value) { 
    commit('setMyInfoState', value);
  },
  setMyInfoCode({ commit }, value) { 
    commit('setMyInfoCode', value);
  },
  setEnabledField({ commit }, value) { 
    commit('setEnabledField', value);
  },
  setIndustryList({ commit }, value) { 
    commit('setIndustryList', value);
  },
  setOccupationList({ commit }, value) { 
    commit('setOccupationList', value);
  },
  setNationalityList({ commit }, value) { 
    commit('setNationalityList', value);
  },
  setIsValidForm({ commit }, payload) { 
      commit('setIsValidForm', payload);
  },
  setRouterTo({ commit }, value) { 
    commit('setRouterTo', value);
  },
  setIsOccupationValid({ commit }, value) { 
    commit('setIsOccupationValid', value);
  },
}

const mutations = {
  setAddress(state, payload){
      state.address = payload
  },
  setDob(state, payload){
      state.dob = payload;
  },
  setEmail(state, payload){
      state.email = payload
  },
  setEmployerName(state, payload){
      state.employerName = payload
  },
  setEmploymentSector(state, payload){
      state.employmentSector = payload
  },
  setFullname(state, payload){
      state.fullName = payload
  },
  setGender(state, payload){
      state.gender = payload
  },
  setIdentificationNo(state, payload){
      state.identificationNo = payload
  },
  setNationality(state, payload){
      state.nationalityId = payload.id
      state.nationality = payload.name
  },
  setOccupation(state, payload){
      state.occupation = payload
  },
  setPassExpiryDate(state, payload){
      state.passExpiryDate = payload
  },
  setPassStatus(state, payload){
      state.passStatus = payload
  },
  setPassType(state, payload){
      state.passType = payload
  },
  setResidentialStatus(state, payload){
      state.residentialStatusId = payload.id;
      state.residentialStatus   = payload.name
  },
  setMyInfoState(state, payload){
      state.myInfoState = payload
  },
  setMyInfoCode(state, payload){
      state.myInfoCode = payload
  },
  setEnabledField(state, payload){
      state.enabledField = payload
  },
  setIndustryList(state, payload){
      state.industryList = payload
  },
  setOccupationList(state, payload){
      state.occupationList = payload
  },
  setNationalityList(state, payload){
      state.nationalityList = payload
  },
  setRouterTo(state, payload){
      state.routerTo = payload
  },
  setIsOccupationValid(state, payload){
      state.validation.isOccupationValid = payload
  },
  setIsIdentificationNoValid(state, payload){
      state.validation.isIdentificationNoValid = payload
  },
  setIsFullnameValid(state, payload){
      state.validation.isFullnameValid = payload
  },
  setIsGenderValid(state, payload){
      state.validation.isGenderValid = payload
  },
  setIsDobValid(state, payload){
      state.validation.isDobValid = payload
  },
  setIsNationalityValid(state, payload){
      state.validation.isNationalityValid = payload
  },
  setIsPassTypeValid(state, payload){
      state.validation.isPassTypeValid = payload
  },
  setIsPassStatusValid(state, payload){
      state.validation.isPassStatusValid = payload
  },
  setIsEmpoymentSectorValid(state, payload){
      state.validation.isEmpoymentSectorValid = payload
  },
  setIsEmailValid(state, payload){
      state.validation.isEmailValid = payload
  },
  setIsAddressValid(state, payload){
      state.validation.isAddressValid = payload
  },
  setIsEmployerValid(state, payload){
      state.validation.isEmployerValid = payload
  },
  setIsValidForm(state, payload){
      state.validation.isValidForm = payload
  },
  loadCheckPreventOnlySpecial(state, isValidCheckOnlySpecial) {
      state.validation.isValidCheckOnlySpecial = isValidCheckOnlySpecial;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}